import React from 'react';
import CustomerForm from "../../Customers/CustomerForm";
import { CustomerProps } from '../types';

interface CustomerSettingsInterface {
    customer: CustomerProps;
}

const CustomerSettings: React.FC<CustomerSettingsInterface> = ({customer}) => {

    return (
        <CustomerForm customer={customer} hideHeader={true} />
    )
};

export default CustomerSettings;
